// GENERATED BY portal-gen — DO NOT EDIT.
//
// Operations deliberately NOT generated, and why. This list is a security boundary, not an
// optimisation: adding one back means adding a screen that needs it.
//
//   stripeWebhook            Stripe HMAC-signature authenticated, not a Firebase JWT. Server-to-server only.
//   authorize                /v1/authz is mTLS, Edge-only. The portal is never an authorizer.
//   getOrgEntitlements       Admin/support cross-org read. The portal uses the self-scoped getMyEntitlements.
//   getAllowedModels         The extension's narrow read. The editor works from the resolved policy document.
//   getSummary               Org-scoped metrics — the Admin Dashboard's surface. 403s for role=member.
//   getTimeseries            Org-scoped metrics — the Admin Dashboard's surface.
//   getBreakdown             Org-scoped metrics — the Admin Dashboard's surface.
//   exportCsv                Org-scoped metrics — the Admin Dashboard's surface.
//   getGuardSummary          Org-scoped metrics — the Admin Dashboard's surface.
//   getSmartSummary          Org-scoped metrics — the Admin Dashboard's surface.
//   getPlanSummary           Org-scoped metrics — the Admin Dashboard's surface.
//   getProviderFallback      Operator metrics.
//   getEntitlementDenials    Operator metrics.
//   getBillingTrialFunnel    Operator metrics.
//   getSsoConfig             v1.1 — /team/sso is not built. Adding it here before the screen is drift.
//   putSsoConfig             v1.1.
//   deleteSsoConfig          v1.1.
//   createScimToken          v1.1 — /team/scim is not built.
//   listScimTokens           v1.1.
//   revokeScimToken          v1.1.
//   updateOrg                No screen renames an org in v1.
//   health                   Liveness. Not a customer-facing call.

import * as identity from "./identity.generated.js";
import * as billing from "./billing.generated.js";
import * as policy from "./policy.generated.js";
import * as entitlements from "./entitlements.generated.js";
import * as metrics from "./metrics.generated.js";

// Namespaced, never `export *`: several contracts legitimately define their own `Plan`,
// `Product` and `SubscriptionStatus`, and flattening them into one namespace would either
// collide or silently pick a winner. Import from the specific contract you mean.
export { identity };
export { billing };
export { policy };
export { entitlements };
export { metrics };

/** Every operation the portal may call, keyed by operationId. */
export const operations = {
  ...identity.identityOperations,
  ...billing.billingOperations,
  ...policy.policyOperations,
  ...entitlements.entitlementsOperations,
  ...metrics.metricsOperations,
} as const;

export type OperationId = keyof typeof operations;
